import classNames from "classnames";
export const Error = ({ id, className, error, ...props }) => {
	return (
		<p id={id} data-testid={id} className={classNames("text-red-500 mb-4 -mt-2 md:-mt-6", className)} {...props}>
			{error}
		</p>
	);
};
